import React from 'react'
import { useModalBehavior, useAuth } from 'hooks'
import { Modal, ModalNavHeader, SuspenseBoundary } from 'elements'
import ModalContent from 'components/app/ModalContent'
import SwitchOrgsList from './SwitchOrgsList'

export default function SwitchCompaniesModal({ modal }) {
  const { currentOrg } = useAuth()
  const modalBehavior = useModalBehavior(modal, {})

  return (
    <Modal modal={modalBehavior}>
      <ModalNavHeader onClose={modal.onClose} titleText="Switch Firm" />
      <ModalContent>
        <SuspenseBoundary>
          <SwitchOrgsList selectedOrg={currentOrg} closeModal={() => modal.onClose()} />
        </SuspenseBoundary>
      </ModalContent>
    </Modal>
  )
}
